import React from 'react';

import { GetFishingWater_fishingWater_intersectingCounties_edges_node } from '../../interfaces/graphql';
import ReactAnd from 'react-and';
import { InternalLink } from '../Clickables/InternalLink/InternalLink';
import { getRegionUrl } from '../../helpers/urls';
import { getUniqueCountiesByRegion } from './helpers/getUniqueCountiesByRegion';

interface IProps {
  regionId?: string | null;
  regionName?: string | null;
  countyName?: string;
  intersectingCounties: GetFishingWater_fishingWater_intersectingCounties_edges_node[];
}

export const IntersectingCountiesLinks = ({
  regionId,
  regionName,
  countyName,
  intersectingCounties,
}: IProps) => {
  if (!regionId || !regionName || !countyName) {
    return null;
  }

  const uniqueCountiesByRegion = getUniqueCountiesByRegion(
    countyName,
    regionId,
    intersectingCounties,
  );

  if (uniqueCountiesByRegion.length === 0) {
    return null;
  }

  return (
    <span data-testid="intersecting-counties-links">
      {`It is also intersecting with `}
      <ReactAnd>
        {uniqueCountiesByRegion.flatMap(({ name, region, country }) => {
          if (!region.regionCode || !region.name || !name) {
            return [];
          }
          return (
            <span key={`cr-${name}-${region.regionCode}`}>
              {`${name}, `}
              <InternalLink
                to={getRegionUrl(country.id, region.regionCode, country.countryName, region.name)}
                className="text-primary"
              >
                {region.name}
              </InternalLink>
            </span>
          );
        })}
      </ReactAnd>
      {`. `}
    </span>
  );
};
